import { useState } from 'react';
import { useAuth } from '../auth/AuthProvider';
import { useToast } from '../ui/Toast';
import { Icon } from '../ui/Icon';

/**
 * Banner de impersonate (F-07). Visível enquanto um super admin está vendo o
 * sistema como uma empresa. Deixa explícito o escopo ativo e oferece saída.
 */
export function ImpersonateBanner() {
  const { impersonate, setImpersonate } = useAuth();
  const toast = useToast();
  const [busy, setBusy] = useState(false);

  if (!impersonate) return null;

  async function exit() {
    if (busy) return;
    setBusy(true);
    await setImpersonate(null);
    setBusy(false);
    toast('Você voltou à visão de super admin', 'info');
  }

  return (
    <div
      role="status"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '9px 16px',
        background: 'var(--amber-tint, var(--bg-2))',
        borderBottom: '1px solid var(--amber, var(--border))',
        color: 'var(--text-1)',
        fontSize: 13
      }}
    >
      <Icon name="eye" size={16} style={{ color: 'var(--amber-strong, var(--text-2))' }} />
      <span style={{ flex: 1 }}>
        Você está vendo o sistema como{' '}
        <strong style={{ fontWeight: 700 }}>{impersonate.nome}</strong>. Dados e ações
        estão escopados a esta empresa.
      </span>
      <button
        onClick={exit}
        disabled={busy}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          padding: '5px 12px',
          borderRadius: 'var(--r-sm)',
          border: '1px solid var(--border)',
          background: 'var(--bg-1)',
          color: 'var(--text-1)',
          fontSize: 12.5,
          fontWeight: 600,
          cursor: busy ? 'default' : 'pointer'
        }}
        onMouseEnter={(e) => (e.currentTarget.style.background = 'var(--bg-2)')}
        onMouseLeave={(e) => (e.currentTarget.style.background = 'var(--bg-1)')}
      >
        <Icon name="logout" size={14} />
        Sair do workspace
      </button>
    </div>
  );
}
